import { ERROR, LOADING, SUCCESS, SUCCESS_BREAKDOWN } from './ThroughputActions';

const INITIAL_STATE = {
  isLoading: true,
  success: false,
  error: '',
  data: [],
  breakdown: [],
};

const ThroughputReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: action.data };
    }
    case SUCCESS_BREAKDOWN: {
      return { ...state, breakdown: action.data };
    }
    default:
      return state;
  }
};

export default ThroughputReducer;
